/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetCompressorScheduleForecastRequest = {
  /**
   * Only return steps since the given time
   */
  since: Date;
  /**
   * Only return steps until the given time
   */
  until: Date;
  agentId: string;
};

/** @internal */
export const GetCompressorScheduleForecastRequest$inboundSchema: z.ZodType<
  GetCompressorScheduleForecastRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  since: types.date(),
  until: types.date(),
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type GetCompressorScheduleForecastRequest$Outbound = {
  since: string;
  until: string;
  agent_id: string;
};

/** @internal */
export const GetCompressorScheduleForecastRequest$outboundSchema: z.ZodType<
  GetCompressorScheduleForecastRequest$Outbound,
  z.ZodTypeDef,
  GetCompressorScheduleForecastRequest
> = z.object({
  since: z.date().transform(v => v.toISOString()),
  until: z.date().transform(v => v.toISOString()),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function getCompressorScheduleForecastRequestToJSON(
  getCompressorScheduleForecastRequest: GetCompressorScheduleForecastRequest,
): string {
  return JSON.stringify(
    GetCompressorScheduleForecastRequest$outboundSchema.parse(
      getCompressorScheduleForecastRequest,
    ),
  );
}
export function getCompressorScheduleForecastRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetCompressorScheduleForecastRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetCompressorScheduleForecastRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetCompressorScheduleForecastRequest' from JSON`,
  );
}
